import { useTranslation } from '@frontend/i18n';
import { Button } from '../../../button';
import { styles } from './date-navigator.styles';
import { DateNavigatorWrapperProps } from './date-navigator.types';

export const DateNavigatorWrapper = ({
  children,
  showNavigationButtons,
  navigationButtonHoverLabel,
  trackingIds,
  handleNavigation,
}: DateNavigatorWrapperProps & { children: React.ReactNode }) => {
  const { t } = useTranslation();

  return (
    <div css={styles.navigatorContainer}>
      {showNavigationButtons && (
        <Button
          variant='secondary'
          size='small'
          iconName='caret-left'
          css={styles.navigationButton}
          trackingId={trackingIds?.prevButton}
          hoverLabel={navigationButtonHoverLabel?.prev || t('Previous Day')}
          onClick={() => handleNavigation(-1)}
        />
      )}
      <div css={{ position: 'relative' }}>{children}</div>
      {showNavigationButtons && (
        <Button
          variant='secondary'
          size='small'
          iconName='caret-right'
          css={styles.navigationButton}
          trackingId={trackingIds?.nextButton}
          hoverLabel={navigationButtonHoverLabel?.next || t('Next Day')}
          onClick={() => handleNavigation(1)}
        />
      )}
    </div>
  );
};
